import { ErrorMessage } from "@hookform/error-message";
import { format, parse } from "date-fns";
import { Controller } from "react-hook-form";
import Datepicker from "react-tailwindcss-datepicker";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
  placeholder?: string;
};

export default function DateInput({ name, placeholder }: Props) {
  return (
    <>
      <Controller
        name={name}
        render={({ field }) => (
          <Datepicker
            primaryColor="emerald"
            inputClassName="w-full rounded-md border-gray-300 focus:ring-0 text-sm text-gray-900 placeholder:text-gray-400"
            useRange={false}
            asSingle={true}
            displayFormat={"MM/DD/YYYY"}
            placeholder={placeholder}
            value={{ startDate: field.value, endDate: field.value }}
            onChange={(value) => {
              const selectedDate =
                value?.startDate != null
                  ? parse(value?.startDate as string, "yyyy-MM-dd", new Date())
                  : null;
              field.onChange(
                selectedDate != null ? format(selectedDate, "MM/dd/yyyy") : "",
              );
            }}
          />
        )}
      />
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorLabel message={message} />}
      />
    </>
  );
}
